import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-json-view',
  templateUrl: './json-view.component.html',
  styleUrls: ['./json-view.component.scss'],
})
export class JsonViewComponent {
  responseData;
  constructor(@Inject(MAT_DIALOG_DATA) private data: any) {
    this.responseData = data;
  }
}
